import React from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";

const { innerWidth: width, innerHeight: height } = window;

const FinanceTabMenu = () => {
    const navigate = useNavigate();
    const { userProfileRole } = getUserData();
    const userRole = userProfileRole;
    return (
        <div
            className="z-2"
            style={{
                flex: 1,
                backgroundColor: "#fff",
                boxShadow: "10px 0px 8px 0 rgba(0,0,0,0.2)",
                position: "fixed",
                width: "100%",
                bottom: 0,
                height: height < 600 ? 60 : 70,
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
            }}
        >
            <div className="cursor-pointer " onClick={() => navigate("/")}>
                <div className="flex justify-content-center align-items-center h-3rem">
                    <img
                        style={{ width: height < 600 ? "20px" : "25px" }}
                        src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Home_Selected.png"
                        alt="logo"
                    />
                </div>
                <p>Home</p>
            </div>
            <div className="cursor-pointer" onClick={() => navigate("/Orders")}>
                <div className="flex justify-content-center align-items-center h-3rem">
                    <img
                        style={{ width: height < 600 ? "37px" : "50px" }}
                        src="/Laundy_App_Icons_Gifs/Customer_Info_GIFs/Running_Order.gif"
                        alt="logo"
                    />
                </div>
                <p>Orders</p>
            </div>
        </div>
    );
};

export default FinanceTabMenu;
